module.exports = __webpack_public_path__ + "static/media/flat(1).3bc24cfa.webp";